const Guaranty = ({
  width = "22px",
  height = "24px",
  currentColor = "currentColor",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="1"
      width="22"
      height="23"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0.999939H21.542V23.4459H0V0.999939Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1518 1.55832L13.0408 2.41832C13.4798 2.84432 14.0918 3.04232 14.6988 2.95632L15.9228 2.78432C16.9828 2.63432 17.9708 3.35132 18.1568 4.40632L18.3708 5.62432C18.4758 6.22732 18.8538 6.74832 19.3948 7.03532L20.4868 7.61432C21.4328 8.11632 21.8108 9.27832 21.3398 10.2403L20.7978 11.3503C20.5288 11.9013 20.5288 12.5443 20.7978 13.0953L21.3398 14.2053C21.8108 15.1673 21.4328 16.3293 20.4868 16.8313L19.3948 17.4113C18.8538 17.6983 18.4758 18.2183 18.3708 18.8213L18.1568 20.0393C17.9708 21.0943 16.9828 21.8123 15.9228 21.6623L14.6988 21.4893C14.0918 21.4033 13.4798 21.6023 13.0408 22.0283L12.1518 22.8873C11.3818 23.6323 10.1608 23.6323 9.3908 22.8873L8.5028 22.0283C8.0618 21.6023 7.4498 21.4033 6.8428 21.4893L5.6198 21.6623C4.5588 21.8123 3.5708 21.0943 3.3858 20.0393L3.1728 18.8213C3.0668 18.2183 2.6878 17.6983 2.1468 17.4113L1.0548 16.8313C0.108803 16.3293 -0.268197 15.1673 0.201803 14.2053L0.744803 13.0953C1.0138 12.5443 1.0138 11.9013 0.744803 11.3503L0.201803 10.2403C-0.268197 9.27832 0.108803 8.11632 1.0548 7.61432L2.1468 7.03532C2.6878 6.74832 3.0668 6.22732 3.1728 5.62432L3.3858 4.40632C3.5708 3.35132 4.5588 2.63432 5.6198 2.78432L6.8428 2.95632C7.4498 3.04232 8.0618 2.84432 8.5028 2.41832L9.3908 1.55832C10.1608 0.813323 11.3818 0.813323 12.1518 1.55832Z"
        fill={currentColor}
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.771 12.2229C18.771 16.6409 15.19 20.2229 10.771 20.2229C6.353 20.2229 2.771 16.6409 2.771 12.2229C2.771 7.8049 6.353 4.2229 10.771 4.2229C15.19 4.2229 18.771 7.8049 18.771 12.2229Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.771 18.6096C7.25 18.6096 4.384 15.7446 4.384 12.2226C4.384 8.70061 7.25 5.83661 10.771 5.83661C14.293 5.83661 17.158 8.70061 17.158 12.2226C17.158 15.7446 14.293 18.6096 10.771 18.6096Z"
      fill={currentColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.6198 15.4257C9.3038 15.4257 9.0078 15.3027 8.7848 15.0797L6.4818 12.7757L7.6838 11.5737L9.6198 13.5087L13.8578 9.27069L15.0598 10.4727L10.4538 15.0807C10.2318 15.3027 9.9348 15.4257 9.6198 15.4257Z"
      fill="white"
    />
  </svg>
);

export default Guaranty;
